export default __webpack_public_path__ + "static/media/quote.ecbda8e6.jpg";